import { readConsent } from "./consent";

type Event =
  | "assistant_cta_clicked"
  | "assistant_registration_completed"
  | "assistant_question_sent"
  | "assistant_answer_received";
type Properties = Record<string, string | boolean>;
type Capture = (event: Event, properties: Properties) => void;

// Browser SDK lifecycle only: neither function runs on the server. A question
// can auto-send before Analytics' lazy import resolves, so retain a small
// consented queue until that configured SDK is ready. Nothing is persisted.
let capture: Capture | undefined;
const pending: Array<[Event, Properties]> = [];

function deliver(event: Event, properties: Properties) {
  if (readConsent() !== "granted") return;
  try {
    capture?.(event, properties);
  } catch {
    /* Analytics must not interrupt chat. */
  }
}

export function initializeAssistantAnalytics(send: Capture): void {
  capture = send;
  for (const [event, properties] of pending.splice(0)) deliver(event, properties);
}

/** Optional telemetry: no question, answer, email or token properties.
 * Navigation and chat never wait for analytics or depend on it. */
export function captureAssistantEvent(event: Event, properties: Properties = {}) {
  if (readConsent() !== "granted") return;
  const safeProperties = {
    ...properties,
    $current_url: window.location.origin + window.location.pathname,
  };
  if (capture) deliver(event, safeProperties);
  else if (pending.length < 20) pending.push([event, safeProperties]);
}
